// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__FCj6B {
  border-bottom: 0.1rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: -16px !important;
}

.styles_tituloContainer__q3u8V {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
  margin-top: -28px !important;
}

.styles_titulo__hsTlq {
  font-size: 44px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_botaoContainer__FsLlI {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
}

.styles_botaoNovo__-cN6j {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 12px !important;
  margin-left: 50% !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__-cN6j:hover {
  transform: scale(0.95) !important;
}

.styles_tituloPopup__xfdeU {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  margin-left: 1rem;
}

.styles_tituloPopupContainer__CFUpT {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__l2ilJ {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__PbnCL {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__PbnCL:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__NqqqB {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__NqqqB:hover {
  transform: scale(0.95) !important;
}

.styles_txtBuscaTabela__DGCnA {
  margin-top: 16px !important;
  margin-left: 74% !important;
}

.styles_iconeBusca__qZ8vy {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
  margin-left: 240px !important;
}

.styles_textoExclusao__jBb9m {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
}

.styles_tituloExclusao__o5tSG {
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  font-size: 44px !important;
}

.styles_botaoPopupExcluir__1zmSl {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  margin-right: 7%;
  margin-bottom: 4%;
}

.styles_botaoPopupExcluir__1zmSl:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelarExclusao__9Atiz {
  width: 120px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  margin-right: 4%;
  margin-bottom: 4%;
}

.styles_botaoPopupCancelarExclusao__9Atiz:hover {
  transform: scale(0.95) !important;
}


/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */

.styles_caixaTextoPequena__ZXdOj {
  height: 28px; /* Ajuste a altura conforme necessário */
}


.styles_caixaDeTexto__XaqP8 {
  margin: 200px 70 !important; 
  height: 30px !important;
}




.styles_botaoVoltar__Xrkbd {
  background-color: #0f2047;
  color: #ffffff;
  border-color: #ffffff;
  border-width: 1px;
  border-style: solid;
  font-family: "Inter";
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
  height: 36px;
}

.styles_botaoVoltar__Xrkbd:hover {
  background-color: #ffffff;
  color: #0f2047;
}


.styles_inputPequeno__ockAB {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adicione mais estilos conforme necessário */
}

.styles_botaoVoltar__Xrkbd:hover {
  background-color: #0f2047;
  color: #ffffff;
}


.styles_labelPequeno__htSBU {
  font-size: 12px; /* Ajuste o valor conforme necessário */
}

.styles_placeholder__xkXVq {
  font-size: 12px; /* Ajuste o valor conforme necessário */
  /* Outros estilos do placeholder, se necessário */
}
`, "",{"version":3,"sources":["webpack://./src/pages/CodFornecedor/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;;AAGA,kGAAkG;;AAElG;EACE,YAAY,EAAE,wCAAwC;AACxD;;;AAGA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;;;;AAKA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,eAAe,EAAE,uCAAuC;EACxD,iDAAiD;AACnD","sourcesContent":[".linhaTitulo {\n  border-bottom: 0.1rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: -16px !important;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n  margin-top: -28px !important;\n}\n\n.titulo {\n  font-size: 44px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.botaoContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n}\n\n.botaoNovo {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 12px !important;\n  margin-left: 50% !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  margin-left: 1rem;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 16px !important;\n  margin-left: 74% !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n  margin-left: 240px !important;\n}\n\n.textoExclusao {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n}\n\n.tituloExclusao {\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  font-size: 44px !important;\n}\n\n.botaoPopupExcluir {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  margin-right: 7%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupExcluir:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelarExclusao {\n  width: 120px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n  margin-right: 4%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupCancelarExclusao:hover {\n  transform: scale(0.95) !important;\n}\n\n\n/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */\n\n.caixaTextoPequena {\n  height: 28px; /* Ajuste a altura conforme necessário */\n}\n\n\n.caixaDeTexto {\n  margin: 200px 70 !important; \n  height: 30px !important;\n}\n\n\n\n\n.botaoVoltar {\n  background-color: #0f2047;\n  color: #ffffff;\n  border-color: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  font-family: \"Inter\";\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n  height: 36px;\n}\n\n.botaoVoltar:hover {\n  background-color: #ffffff;\n  color: #0f2047;\n}\n\n\n.inputPequeno {\n  width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  /* Adicione mais estilos conforme necessário */\n}\n\n.botaoVoltar:hover {\n  background-color: #0f2047;\n  color: #ffffff;\n}\n\n\n.labelPequeno {\n  font-size: 12px; /* Ajuste o valor conforme necessário */\n}\n\n.placeholder {\n  font-size: 12px; /* Ajuste o valor conforme necessário */\n  /* Outros estilos do placeholder, se necessário */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__FCj6B`,
	"tituloContainer": `styles_tituloContainer__q3u8V`,
	"titulo": `styles_titulo__hsTlq`,
	"botaoContainer": `styles_botaoContainer__FsLlI`,
	"botaoNovo": `styles_botaoNovo__-cN6j`,
	"tituloPopup": `styles_tituloPopup__xfdeU`,
	"tituloPopupContainer": `styles_tituloPopupContainer__CFUpT`,
	"botoesPopupGeral": `styles_botoesPopupGeral__l2ilJ`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__PbnCL`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__NqqqB`,
	"txtBuscaTabela": `styles_txtBuscaTabela__DGCnA`,
	"iconeBusca": `styles_iconeBusca__qZ8vy`,
	"textoExclusao": `styles_textoExclusao__jBb9m`,
	"tituloExclusao": `styles_tituloExclusao__o5tSG`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__1zmSl`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__9Atiz`,
	"caixaTextoPequena": `styles_caixaTextoPequena__ZXdOj`,
	"caixaDeTexto": `styles_caixaDeTexto__XaqP8`,
	"botaoVoltar": `styles_botaoVoltar__Xrkbd`,
	"inputPequeno": `styles_inputPequeno__ockAB`,
	"labelPequeno": `styles_labelPequeno__htSBU`,
	"placeholder": `styles_placeholder__xkXVq`
};
export default ___CSS_LOADER_EXPORT___;
